import React from 'react';
import Routes from './routes/routes';

const Public = () => <Routes />;

export default Public;
